require('./hiringProductInformationFaq.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @commons
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');

class HiringProductInformationFaq extends React.Component {

    buildFaqs(immFaqs) {
        return immFaqs.map(immFaq => {
            const key = immFaq.get('id');
            const question = immFaq.get('question');
            const answer = immFaq.get('answer');
            return (
                <Accordion
                    customClassName="hiring-product-information-faq__content"
                    key={key}
                >
                    <AccordionHeader
                        name="AccordionHeader"
                        iconStyle="secondary"
                        isRightArrowPosition
                    >
                        <div className="hiring-product-information-faq__question">
                            {question}
                        </div>
                    </AccordionHeader>
                    <AccordionBody name="AccordionBody">
                        <HTMLSafeInjector
                            message={answer}
                        />
                    </AccordionBody>
                </Accordion>
            );
        });
    }

    render() {
        const { immFaqs } = this.props;
        const faqContent = this.buildFaqs(immFaqs);

        return (
            <div className="hiring-product-information-faq">
                {faqContent}
            </div>
        );
    }
}

HiringProductInformationFaq.propTypes = {
    immFaqs: PropTypes.object.isRequired,
};

module.exports = HiringProductInformationFaq;
